import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import Routes from 'routes';
import themes from 'themes';
import NavigationScroll from 'layout/NavigationScroll';
import AuthProvider from 'component/AuthProvider';
import AppInitializer from 'component/AppInitializer';
import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { msalInstance } from 'authConfig';
import { Toaster } from 'react-hot-toast';
import 'katex/dist/katex.min.css';
import { GetAccessToken } from 'utils/access-token';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 5000,
            style: {
              marginTop: 60,
              background: "#363636",
              color: "#fff",
            },
          }}
        />
        <CssBaseline />
        <AppInitializer>
          <AuthProvider>
            <NavigationScroll>
              <Routes />
            </NavigationScroll>
          </AuthProvider>
        </AppInitializer>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;